import { Directive, ElementRef, Input, HostListener } from "@angular/core";

@Directive({
  selector: "[OnlyCharacterDirective]",
})
export class OnlyCharacterDirective {
  constructor(private el: ElementRef) {}
  @Input()
  OnlyCharacterDirective: boolean;
  @HostListener("keydown", ["$event"])
  onKeyDown(event) {
    const e = <KeyboardEvent>event;
    if (this.OnlyCharacterDirective) {
      if (
        [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39) ||
        (e.keyCode >= 91 && e.keyCode <= 96)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (e.shiftKey || e.keyCode < 65 || e.keyCode > 122) {
        e.preventDefault();
      }
    }
  }
}
